// extracted by mini-css-extract-plugin
export default {"pageWrapper":"MainLayout_pageWrapper__lWmGZ","content":"MainLayout_content__dmYK2"};